// extracted by mini-css-extract-plugin
module.exports = {"modalForm":"styles_modalForm__3AMeg","buttons":"styles_buttons__14xwQ"};